<script lang="ts">
  import { onDestroy, onMount } from "svelte"
  import { Layout, DefaultTable } from "../../components"
  import { navigateCustom } from "../../utils/navigateCustom"
  import { getChannels } from "../../services/endpoints"
  import { DataCell, Tag } from "@gl/design-system"
  import { _ } from "svelte-i18n"
  import type { Channel, Timeline } from "../../services/models"
  import { format, parseJSON } from "date-fns"

  let table;
  let data: Channel[] = [];
  let loading = true;
  let searchText = "";
  let newButton = {
    enabled: true,
    text: $_("channels.new"),
    link: "/channels/create" 
  }
  let limit = 10
  let offset = 0
  let totalCount = 0
  let interval: NodeJS.Timeout;

  onMount(() => {
    search()
    interval = setInterval(() => {search(true)}, 10 * 1000)
  })

  onDestroy(() => {
    clearInterval(interval)
  })

  const search = (runInBackground = false) => {
    loading = !runInBackground
    getChannels(limit, offset, searchText).then(ch => {data = ch.list; totalCount = ch.meta.count; loading = false;})
  }

  const transformTimelines = (timelines: { [key: string]: Timeline}) => {
    return Object.values(timelines).map(t => {
      let start = parseJSON(t.startDateTime)
      let end = start.getTime() + t.durationMs
      return "<p>" + format(new Date(start), "yyyy-MM-dd HH:mm") + " - " + format(new Date(end), "yyyy-MM-dd HH:mm") + "</p>"
    }).join("")
  }

</script>

<Layout selected="channels">
  <DefaultTable
    title={ $_("common.channels") }
    {newButton}
    {data}
    {loading}
    bind:limit={limit}
    bind:offset={offset}
    bind:totalCount={totalCount}
    bind:searchText={searchText}
    on:search={search}
    let:row
    let:index >
    <DataCell {index} header="Name"><a on:mouseup={(e) => navigateCustom("/channels/" + row.uuid, e)}>{ row.name }</a></DataCell>
    <DataCell {index} header="Timelines">{@html transformTimelines(row.timelines) }</DataCell>
    <DataCell {index} header="ExternalID">{ row.externalId ?? "" }</DataCell>
    <DataCell {index} header="Streams">{ row.streams.length }</DataCell>
    <DataCell {index} header="Active">
      <Tag status={row.active ? "success" : ""}>{row.active ? "active" : "inactive"}</Tag>
    </DataCell>
  </DefaultTable>
</Layout>